import { Product } from "../hooks/types";
import { getProductName } from "../transforms";
import { Account, EnhancedAccount, Region } from "./types";

export function enhanceAccounts(
  accounts: Account[],
  products: Product[],
): EnhancedAccount[] {
  return accounts.map((account) => {
    const product = products.find((p) => p.id === account.product_id);
    const productName: string = product ? getProductName(product) : "";
    const region: Region = product?.region === "NZ" ? "NZ" : "AU";

    return { ...account, productName, region };
  });
}
